// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.create-diet-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  max-width: 1300px;
  margin: 0 auto;
}

.diet-section {
  display: flex;
  justify-content: space-between;
  width: 100%;
  gap: 30px;
  margin-top: 30px;
}

.diet-left, .diet-right {
  width: 100%;
  min-width: 600px;
  flex: 1 1;
  display: flex;
  flex-direction: column;
}

.history-dropdown-group {
  margin-bottom: 20px;
}

.styled-dropdown.small-dropdown {
  width: 100%;
  max-width: 300px;
}

.dropdown-group {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
}

.styled-dropdown {
  flex: 1 1;
  padding: 10px;
  border-radius: 8px;
  border: 1px solid #ddd;
  font-size: 16px;
}

.small-dropdown {
  width: 100%;
  max-width: 300px;
}

.diet-input-container {
  margin-top: 20px;
}

.diet-input {
  width: 100%;
  min-height: 300px;
  border-radius: 8px;
  padding: 15px;
  border: 1px solid #ddd;
  background-color: #f9f9f9;
}

.rich-editor {
  background-color: white;
}

.view-only .ql-editor {
  padding: 10px 12px;
}

.button-group {
  display: flex;
  gap: 15px;
  margin-top: 20px;
  align-items: center;
}

.save-btn, .cancel-btn {
  padding: 10px 20px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 45px;
  min-width: 120px;
}

.save-btn {
  background-color: #4CAF50;
  color: white;
}

.save-btn:hover {
  background-color: #45a049;
}

.save-btn:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}

.cancel-btn {
  background-color: #f44336;
  color: white;
}

.cancel-btn:hover {
  background-color: #d32f2f;
}

.diet-left {
  position: relative;
}

.diet-left .save-btn,
.diet-left .cancel-btn {
  margin: 0;
  vertical-align: top;
}

.history-section {
  width: 100%;
  margin-bottom: 30px;
}

.history-table-container {
  width: 100%;
  /* overflow-x: auto; */
}

.weight-history-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
}

.weight-history-table th,
.weight-history-table td {
  padding: 12px;
  border: 1px solid #ddd;
  text-align: left;
}

.weight-history-table th {
  background-color: #4CAF50;
  font-weight: bold;
}

.weight-history-table tr:nth-child(even) {
  background-color: #f9f9f9;
}

.weight-history-table tr:hover {
  background-color: #f1f1f1;
}

.no-data {
  text-align: center;
  padding: 20px;
  color: #666;
}

.diet-toggle-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 20px 0;
}

.diet-type-heading {
  margin-bottom: 15px;
  margin-top: -20px;
  font-size: 1.2rem;
  font-weight: 600;
}

.segmented-control {
  display: flex;
  background-color: white;
  border-radius: 12px;
  overflow: hidden;
  padding: 4px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  width: 100%;
  max-width: 430px;
}

.segment {
  flex: 1 1;
  padding: 12px 16px;
  text-align: center;
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 0.95rem;
  font-weight: 500;
  color: #555;
  transition: all 0.2s ease-in-out;
  margin: 0 3px;
  border-radius: 8px;
}

.segment-active {
  flex: 1 1;
  padding: 12px 16px;
  text-align: center;
  border: none;
  background-color: #004D40;
  color: white;
  cursor: pointer;
  font-size: 0.95rem;
  font-weight: 600;
  transition: all 0.2s ease-in-out;
  margin: 0 3px;
  border-radius: 8px;
}

.segment:hover:not(.segment-active) {
  background-color: rgba(0, 0, 0, 0.04);
}

.action-buttons {
  display: flex;
  gap: 8px;
}

.action-button {
  padding: 6px 12px;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
  color: white;
}

.action-use {
  background-color: #4CAF50;
}

.action-view {
  background-color: #2196F3;
}

.action-edit {
  background-color: #FF9800;
}

.action-delete {
  background-color: #F44336;
}

.action-button:hover {
  opacity: 0.9;
  transform: translateY(-1px);
}

.action-button:active {
  transform: translateY(0);
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.delete-modal {
  background-color: white;
  padding: 25px;
  border-radius: 8px;
  width: 400px;
  max-width: 90%;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.delete-modal h3 {
  margin-top: 0;
  color: #d32f2f;
}

.delete-modal p {
  margin: 15px 0 25px;
  color: #555;
}

.modal-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.modal-button {
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.2s ease;
}

.modal-cancel {
  background-color: #f0f0f0;
  color: #333;
}

.modal-cancel:hover {
  background-color: #e0e0e0;
}

.modal-confirm {
  background-color: #d32f2f;
  color: white;
}

.modal-confirm:hover {
  background-color: #b71c1c;
}

@media (max-width: 768px) {
  .diet-section {
    flex-direction: column;
    gap: 30px;
  }
  
  .dropdown-group {
    flex-direction: column;
    gap: 15px;
  }
  
  .segmented-control {
    max-width: 100%;
  }
}

.weight-history-table {
  margin: 0 auto;
  width: 95%;
}

.success-message-container {
  position: fixed;
  top: 70px; 
  left: 0;
  right: 0;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: none; 
}

.success-message9 {
  color: #155724;
  background-color: #d4edda;
  border: 1px solid #c3e6cb;
  padding: 12px 20px;
  border-radius: 15px;
  font-weight: 600;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  display: inline-flex;
  align-items: center;
  max-width: 60% !important;
  text-align: center;
  animation: fadeInOut 3s ease-in-out forwards;
}

.error-message9 {
  color: #d32f2f;
  background-color: #fde7e9;
  border: 1px solid #d32f2f;
  padding: 12px;
  border-radius: 10px;
  display: flex !important;
  align-items: center !important;
  gap: 8px;
  margin: 10px auto !important; 
  font-weight: 600;
  width: 40%;
  justify-content: center !important;
  text-align: center;
}

@keyframes fadeInOut {
  0% { opacity: 0; transform: translateY(-20px); }
  10% { opacity: 1; transform: translateY(0); }
  90% { opacity: 1; transform: translateY(0); }
  100% { opacity: 0; transform: translateY(-20px); }
}  

.template-dropdown {
  width: 100%;
  max-width:400px !important;
  min-width: 300px;
}

.group-dropdown-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 30px;
}

.group-error-message {
  color: #d32f2f;
  background-color: #fde7e9;
  border: 1px solid #d32f2f;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  width: 100%;
  max-width: 300px;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/styles/CommonDietPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,SAAO;EACP,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,yCAAyC;EACzC,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,gCAAgC;EAChC,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,QAAQ;EACR,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,sCAAsC;EACtC,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,wBAAwB;EACxB,8BAA8B;EAC9B,QAAQ;EACR,4BAA4B;EAC5B,gBAAgB;EAChB,UAAU;EACV,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,KAAK,UAAU,EAAE,4BAA4B,EAAE;EAC/C,MAAM,UAAU,EAAE,wBAAwB,EAAE;EAC5C,MAAM,UAAU,EAAE,wBAAwB,EAAE;EAC5C,OAAO,UAAU,EAAE,4BAA4B,EAAE;AACnD;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB","sourcesContent":[".create-diet-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 20px;\n  max-width: 1300px;\n  margin: 0 auto;\n}\n\n.diet-section {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  gap: 30px;\n  margin-top: 30px;\n}\n\n.diet-left, .diet-right {\n  width: 100%;\n  min-width: 600px;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n}\n\n.history-dropdown-group {\n  margin-bottom: 20px;\n}\n\n.styled-dropdown.small-dropdown {\n  width: 100%;\n  max-width: 300px;\n}\n\n.dropdown-group {\n  display: flex;\n  gap: 20px;\n  margin-bottom: 20px;\n}\n\n.styled-dropdown {\n  flex: 1;\n  padding: 10px;\n  border-radius: 8px;\n  border: 1px solid #ddd;\n  font-size: 16px;\n}\n\n.small-dropdown {\n  width: 100%;\n  max-width: 300px;\n}\n\n.diet-input-container {\n  margin-top: 20px;\n}\n\n.diet-input {\n  width: 100%;\n  min-height: 300px;\n  border-radius: 8px;\n  padding: 15px;\n  border: 1px solid #ddd;\n  background-color: #f9f9f9;\n}\n\n.rich-editor {\n  background-color: white;\n}\n\n.view-only .ql-editor {\n  padding: 10px 12px;\n}\n\n.button-group {\n  display: flex;\n  gap: 15px;\n  margin-top: 20px;\n  align-items: center;\n}\n\n.save-btn, .cancel-btn {\n  padding: 10px 20px;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  border: none;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  height: 45px;\n  min-width: 120px;\n}\n\n.save-btn {\n  background-color: #4CAF50;\n  color: white;\n}\n\n.save-btn:hover {\n  background-color: #45a049;\n}\n\n.save-btn:disabled {\n  background-color: #cccccc;\n  cursor: not-allowed;\n}\n\n.cancel-btn {\n  background-color: #f44336;\n  color: white;\n}\n\n.cancel-btn:hover {\n  background-color: #d32f2f;\n}\n\n.diet-left {\n  position: relative;\n}\n\n.diet-left .save-btn,\n.diet-left .cancel-btn {\n  margin: 0;\n  vertical-align: top;\n}\n\n.history-section {\n  width: 100%;\n  margin-bottom: 30px;\n}\n\n.history-table-container {\n  width: 100%;\n  /* overflow-x: auto; */\n}\n\n.weight-history-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 20px;\n}\n\n.weight-history-table th,\n.weight-history-table td {\n  padding: 12px;\n  border: 1px solid #ddd;\n  text-align: left;\n}\n\n.weight-history-table th {\n  background-color: #4CAF50;\n  font-weight: bold;\n}\n\n.weight-history-table tr:nth-child(even) {\n  background-color: #f9f9f9;\n}\n\n.weight-history-table tr:hover {\n  background-color: #f1f1f1;\n}\n\n.no-data {\n  text-align: center;\n  padding: 20px;\n  color: #666;\n}\n\n.diet-toggle-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin: 20px 0;\n}\n\n.diet-type-heading {\n  margin-bottom: 15px;\n  margin-top: -20px;\n  font-size: 1.2rem;\n  font-weight: 600;\n}\n\n.segmented-control {\n  display: flex;\n  background-color: white;\n  border-radius: 12px;\n  overflow: hidden;\n  padding: 4px;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n  width: 100%;\n  max-width: 430px;\n}\n\n.segment {\n  flex: 1;\n  padding: 12px 16px;\n  text-align: center;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  font-size: 0.95rem;\n  font-weight: 500;\n  color: #555;\n  transition: all 0.2s ease-in-out;\n  margin: 0 3px;\n  border-radius: 8px;\n}\n\n.segment-active {\n  flex: 1;\n  padding: 12px 16px;\n  text-align: center;\n  border: none;\n  background-color: #004D40;\n  color: white;\n  cursor: pointer;\n  font-size: 0.95rem;\n  font-weight: 600;\n  transition: all 0.2s ease-in-out;\n  margin: 0 3px;\n  border-radius: 8px;\n}\n\n.segment:hover:not(.segment-active) {\n  background-color: rgba(0, 0, 0, 0.04);\n}\n\n.action-buttons {\n  display: flex;\n  gap: 8px;\n}\n\n.action-button {\n  padding: 6px 12px;\n  border: none;\n  border-radius: 4px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: all 0.2s;\n  color: white;\n}\n\n.action-use {\n  background-color: #4CAF50;\n}\n\n.action-view {\n  background-color: #2196F3;\n}\n\n.action-edit {\n  background-color: #FF9800;\n}\n\n.action-delete {\n  background-color: #F44336;\n}\n\n.action-button:hover {\n  opacity: 0.9;\n  transform: translateY(-1px);\n}\n\n.action-button:active {\n  transform: translateY(0);\n}\n\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.delete-modal {\n  background-color: white;\n  padding: 25px;\n  border-radius: 8px;\n  width: 400px;\n  max-width: 90%;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n}\n\n.delete-modal h3 {\n  margin-top: 0;\n  color: #d32f2f;\n}\n\n.delete-modal p {\n  margin: 15px 0 25px;\n  color: #555;\n}\n\n.modal-buttons {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n}\n\n.modal-button {\n  padding: 8px 16px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 500;\n  transition: all 0.2s ease;\n}\n\n.modal-cancel {\n  background-color: #f0f0f0;\n  color: #333;\n}\n\n.modal-cancel:hover {\n  background-color: #e0e0e0;\n}\n\n.modal-confirm {\n  background-color: #d32f2f;\n  color: white;\n}\n\n.modal-confirm:hover {\n  background-color: #b71c1c;\n}\n\n@media (max-width: 768px) {\n  .diet-section {\n    flex-direction: column;\n    gap: 30px;\n  }\n  \n  .dropdown-group {\n    flex-direction: column;\n    gap: 15px;\n  }\n  \n  .segmented-control {\n    max-width: 100%;\n  }\n}\n\n.weight-history-table {\n  margin: 0 auto;\n  width: 95%;\n}\n\n.success-message-container {\n  position: fixed;\n  top: 70px; \n  left: 0;\n  right: 0;\n  z-index: 1000;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  pointer-events: none; \n}\n\n.success-message9 {\n  color: #155724;\n  background-color: #d4edda;\n  border: 1px solid #c3e6cb;\n  padding: 12px 20px;\n  border-radius: 15px;\n  font-weight: 600;\n  box-shadow: 0 2px 10px rgba(0,0,0,0.1);\n  display: inline-flex;\n  align-items: center;\n  max-width: 60% !important;\n  text-align: center;\n  animation: fadeInOut 3s ease-in-out forwards;\n}\n\n.error-message9 {\n  color: #d32f2f;\n  background-color: #fde7e9;\n  border: 1px solid #d32f2f;\n  padding: 12px;\n  border-radius: 10px;\n  display: flex !important;\n  align-items: center !important;\n  gap: 8px;\n  margin: 10px auto !important; \n  font-weight: 600;\n  width: 40%;\n  justify-content: center !important;\n  text-align: center;\n}\n\n@keyframes fadeInOut {\n  0% { opacity: 0; transform: translateY(-20px); }\n  10% { opacity: 1; transform: translateY(0); }\n  90% { opacity: 1; transform: translateY(0); }\n  100% { opacity: 0; transform: translateY(-20px); }\n}  \n\n.template-dropdown {\n  width: 100%;\n  max-width:400px !important;\n  min-width: 300px;\n}\n\n.group-dropdown-container {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-bottom: 30px;\n}\n\n.group-error-message {\n  color: #d32f2f;\n  background-color: #fde7e9;\n  border: 1px solid #d32f2f;\n  padding: 8px 12px;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 500;\n  width: 100%;\n  max-width: 300px;\n  text-align: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
